export default __webpack_public_path__ + "static/media/Travel & Leisure.b07d9845.jpg";